import fetchWebApi from 'api/fetchWebApi';

const putIdentificationManualApiCall = async (): Promise<void> => {
  fetchWebApi('/client/identification/manual', undefined, {
    method: 'put',
  });
};

export default putIdentificationManualApiCall;
